import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";

function InfoRow({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 6 }}>
      <span style={{ color: "#6b7280" }}>{label}</span>
      <b>{value ?? "-"}</b>
    </div>
  );
}

function InputTime({ label, value, onChange }) {
  return (
    <div style={{ marginTop: 12 }}>
      <label style={{ fontSize: 13, color: "#6b7280" }}>{label}</label>
      <input
        type="time"
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{
          width: "100%",
          marginTop: 4,
          padding: "10px 12px",
          borderRadius: 12,
          border: "1px solid #e5e7eb",
          fontSize: 14,
        }}
      />
    </div>
  );
}

// Tentukan status absen
const getStatus = (r) => {
  if (!r?.jam_masuk || !r?.jam_pulang) return "Perlu Revisi";
  if (r.telat === 1) return "Terlambat";
  return "Hadir";
};

export default function AbsenEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [record, setRecord] = useState(null);
  const [jamMasuk, setJamMasuk] = useState("");
  const [jamPulang, setJamPulang] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem("lapor_lupa_absen");

    if (!raw) return;

    try {
      const list = JSON.parse(raw);
      const found = list.find(item => Number(item.absen_id) === Number(id));

      const cleanTime = (time) => {
        if (!time || time === '-' || time === '00:00:00' || time === '00:00') return '';
        
        // Normalisasi: Ganti titik (.) dengan titik dua (:) jika ada (kasus 17.00.28)
        const normalizedTime = String(time).replace(/\./g, ':');
        
        const parts = normalizedTime.split(':');
        if (parts.length >= 2) {
          const h = parts[0].padStart(2, '0');
          const m = parts[1].padStart(2, '0');
          const s = parts[2] ? parts[2].padStart(2, '0') : '00';
          return `${h}:${m}:${s}`;
        }
        return '';
      };

      if (found) {
        setRecord(found);
        setJamMasuk(cleanTime(found.jam_masuk));
        setJamPulang(cleanTime(found.jam_pulang));
      } else {
        console.log(`Tidak ditemukan record dengan absen_id = ${id}`);
      }
    } catch (e) {
      console.error("Gagal parsing localStorage 'lapor_lupa_absen':", e);
    }
  }, [id]);function AbsenEdit({ records, record }) {
  const data = records || (record ? [record] : []);

  if (data.length === 0) return <div>Tidak ada data</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
      {data.map((item) => (
        <AbsenEditForm key={item.id} initialRecord={item} />
      ))}
    </div>
  );
}

  const status = useMemo(() => getStatus(record), [record]);

  const koordinat = useMemo(() => {
    if (!record?.lokasi) return null;
    const [lat, lng] = record.lokasi.split(",").map(v => v.trim());
    return { lat, lng };
  }, [record]);

  const handleSubmit = async () => {
    if (!record) return;

    setSaving(true);

    const payload = {
      id: record.id,
      jam_masuk: jamMasuk || record.jam_masuk,
      jam_pulang: jamPulang || record.jam_pulang,
    };

    try {
      const res = await fetch("/api/absen/edit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Gagal update");

      // 🔄 Update localStorage lapor_lupa_absen
      const list = JSON.parse(localStorage.getItem("lapor_lupa_absen") || "[]");
      const updated = list.map(item =>
        item.id === record.id ? { ...item, ...payload } : item
      );

      localStorage.setItem("lapor_lupa_absen", JSON.stringify(updated));

      alert("Berhasil menyimpan perubahan");
      navigate(-1);
    } catch (e) {
      console.error(e);
      alert("Gagal menyimpan perubahan");
    } finally {
      setSaving(false);
    }
  };

  if (!record) {
    return <div style={{ padding: 24 }}>Data absen tidak ditemukan</div>;
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f2f5ff" }}>
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        style={{
          width: 360,
          background: "linear-gradient(180deg,#4f7cff,#3b5bdb)",
          borderRadius: 28,
          padding: 20,
          color: "white",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 12 }}>Edit Absensi</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{record.nama}</div>
            <div style={{ fontSize: 12 }}>{record.tanggal}</div>
          </div>

          <div
            style={{
              padding: "6px 12px",
              borderRadius: 20,
              background:
                status === "Hadir"
                  ? "#22c55e"
                  : status === "Terlambat"
                  ? "#f59e0b"
                  : "#ef4444",
            }}
          >
            {status}
          </div>
        </div>

        {/* Detail */}
        <div style={{ marginTop: 16, background: "white", color: "#1f2937", borderRadius: 20, padding: 16 }}>
          <InfoRow label="Jadwal" value={record.jadwal} />
          <InfoRow label="Jam Masuk" value={record.jam_masuk} />
          <InfoRow label="Jam Pulang" value={record.jam_pulang} />
          <InfoRow label="Log" value={record.log} />
          <InfoRow label="Lokasi" value={koordinat ? `${koordinat.lat}, ${koordinat.lng}` : "-"} />

          <InputTime label="Jam Masuk" value={jamMasuk} onChange={setJamMasuk} />
          <InputTime label="Jam Pulang" value={jamPulang} onChange={setJamPulang} />
        </div>

        {/* Action */}
        <div style={{ display: "flex", gap: 12, marginTop: 14 }}>
          <button onClick={() => navigate(-1)} style={{ flex: 1 }}>Batal</button>
          <button onClick={handleSubmit} disabled={saving} style={{ flex: 1 }}>
            {saving ? "Menyimpan..." : "Simpan"}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
